export default {
    SET_CUSTOMERS: (state, customers) => {
        state.customers = customers
    },

    SET_ACTIVE_CUSTOMER: (state, activeCustomer) => {
        state.activeCustomer = activeCustomer
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_FILTERS: (state) => {
        state.filters = {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            email: null,
            phone: null
        }
    }
}
